<app-modal-embedded (close)="onClose()">
  <router-outlet></router-outlet>
</app-modal-embedded>
